import styled from "styled-components";

export const Container = styled.div`
  background: 0% 0% no-repeat padding-box padding-box rgb(0, 15, 255);
  opacity: 1;
  display: flex;
  flex-direction: column;
`;

export const ContentLoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (max-height: 762px) {
    gap: 16px;
  }
`;

export const DegradeDesktop = styled.div`
  z-index: 2;
  position: absolute;
  width: 35%;
  height: 75vh;
  left: 25%;
  background: linear-gradient(
      270deg,
      rgb(0, 255, 0) 0%,
      rgb(0, 255, 246) 52%,
      rgb(0, 255, 255) 100%
    )
    center top no-repeat padding-box padding-box transparent;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DegradeMobile = styled.div`
  z-index: 2;
  position: absolute;
  width: 100vw;
  height: 100vh;
  bottom: -15%;
  background: url(/static/ondas.6cce42b5.png) no-repeat;
  display: none;
  flex-direction: column;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const Content = styled.div`
  z-index: 3;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  padding-bottom: 20px;

  @media (max-width: 768px) {
    overflow: auto;
    height: fit-content;
  }
`;

export const ContentLogo = styled.div`
  width: 25%;
  height: 100vh;

  @media (max-width: 768px) {
    display: none;
    height: 100%;
  }
`;

export const Logo = styled.img`
  padding-top: 45px;
  padding-left: 10%;
  width: 80%;
  height: auto;
`;

export const ContentImages = styled.div`
  width: 40%;
  height: 100vh;

  @media (max-width: 768px) {
    display: none;
  }
`;

type ImageProps = {
  isActive: boolean;
};

export const Image = styled.img<ImageProps>`
  position: absolute;
  left: 23%;
  bottom: 0px;
  width: 40%;
  height: auto;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transition: opacity 2s ease 0s;
`;

export const ContentLogin = styled.div`
  width: 38%;
  height: 100vh;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    position: inherit;
  }
`;

export const ContentAlign = styled.div`
  width: 70%;
  height: fit-content;
  padding: 28px 0;

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-left: 6%;
    margin-right: 2%;
    padding: 18px 0;
  }

  @media (max-width: 450px) {
    margin-left: 2%;
  }
`;

export const ContentAlignLogo = styled.div`
  width: 100%;
  padding: 10px 0px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const AlignLogo = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;

  h2 {
    color: ${({ theme }) => theme.colors.white};
    font-family: "Mangueira Bold";
    font-size: 33px;
    text-align: center;
  }

  div {
    display: flex;
    gap: 10px;

    span {
      text-align: right;
      color: ${({ theme }) => theme.colors.white};
      font-family: "Mangueira Medium";
    }
  }

  @media (max-width: 1024px) {
    margin-right: -120px;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    width: 280px;

    h2 {
      font-size: 25px;
    }

    div {
      gap: 5px;

      span {
        font-size: 12px;
      }
    }
  }
`;

export const TextMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const AlignLogoMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    h2 {
      color: ${({ theme }) => theme.colors.white};
      font-family: "Mangueira Bold";
      font-size: 23px;
      text-align: center;
      margin: 0;
    }
    span {
      text-align: center;
      color: ${({ theme }) => theme.colors.white};
      font-family: "Mangueira Medium";
      font-size: 12px;
      max-width: 306px;
    }
  }
`;

export const ContentLogoMobile = styled.div`
  width: 96%;
  height: fit-content;
  display: none;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const LogoMobile = styled.img`
  height: auto;

  @media (max-width: 768px) {
    width: 30%;
  }

  @media (max-width: 600px) {
    width: 40%;
  }

  @media (max-width: 450px) {
    width: 50%;
  }
`;

export const ContentAlignLogin = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  min-height: 33%;
  padding: 25px;
  background-color: rgb(255, 255, 255);
  border-radius: 21px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 3px 6px;

  @media (max-width: 768px) {
    align-items: center;
    width: 96%;
  }

  @media (max-width: 450px) {
    width: 100%;
  }

  @media (max-height: 762px) {
    padding: 18px 25px;
  }
`;

export const ContentBanner = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 10%;
  padding: 80px 30px;
  background: linear-gradient(
      270deg,
      rgb(0, 255, 255) 0%,
      rgb(0, 255, 246) 52%,
      rgb(0, 255, 0) 100%
    )
    center top no-repeat padding-box padding-box transparent;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 35px 4%;
    padding-bottom: 150px;
    gap: 35px;
  }

  @media (max-height: 762px) {
    padding: 18px 30px;
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: calc(100% / 3);
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TextBanner = styled.span`
  font-size: 16px;
  font-family: "Mangueira Bold";
  color: ${({ theme }) => theme.colors.black2};
  text-align: center;
`;

export const LinkBanner = styled.a`
  padding: 5px 10px;
  width: 100%;
  color: ${({ theme }) => theme.colors.white} !important;
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    opacity: 0.85;
  }
`;

export const TitleMobileWrapper = styled.div``;

export const TitleWeb = styled.h2`
  color: ${({ theme }) => theme.colors.white};
  font-family: "Mangueira Bold";
  font-size: 33px;
  text-align: center;
`;

export const TextWebWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const AlignLogoWeb = styled.div`
  padding: 0 18px;
`;

export const TextWeb = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-family: "Mangueira Medium";
`;

export const TextLogoMobileWrapper = styled.div``;

export const ImageTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: center;
`;
